import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { typographyFor } from "../lib/typography";

export const DEFAULT_LEGAL_MENTIONS = {
  title: "Mentions légales",
  updatedAt: "4 juillet 2026",
  sections: [
  {
    title: "1. Éditeur du site",
    content: [
      "Le présent site internet est édité par Unlimited Session, nom commercial de l’entreprise individuelle Sow Yero Malick, immatriculée au Registre National des Entreprises sous le numéro 943 869 438.",
    ],
    details: [
      ["Nom commercial", "Unlimited Session"],
      ["Entrepreneur individuel", "Sow Yero Malick"],
      ["SIREN", "943 869 438"],
      ["SIRET", "943 869 438 00011"],
      ["Code APE", "5920Z - Enregistrement sonore et édition musicale"],
      ["Siège social", "28 Avenue des Pépinières, 94260 Fresnes, France"],
      ["Téléphone", "+33 6 15 29 58 39"],
      ["E-mail", "unlimitedsession@gmail.com"],
      ["Directeur de la publication", "Yero Malick Sow"],
      ["TVA", "TVA non applicable, article 293 B du Code général des impôts."],
    ],
  },
  {
    title: "2. Hébergement",
    content: [
      "Le site est hébergé par :",
      "GoDaddy Operating Company, LLC\n2155 E. GoDaddy Way\nTempe, Arizona 85284\nÉtats-Unis",
      "Site internet : www.godaddy.com",
      "GoDaddy intervient uniquement en qualité de prestataire technique chargé de l’hébergement du site.",
    ],
  },
  {
    title: "3. Activité du site",
    content: [
      "Unlimited Session exerce notamment une activité de production musicale, enregistrement sonore, édition musicale, développement artistique, mise en avant d’artistes, exploitation de contenus musicaux, promotion culturelle, communication digitale, ainsi que la commercialisation de produits dérivés.",
      "Le site peut également proposer des vêtements, accessoires et articles textiles commercialisés sous la marque Unlimited Session ou dans le cadre de collaborations, notamment avec LATDIOR Paris.",
    ],
  },
  {
    title: "4. Propriété intellectuelle",
    content: [
      "L’ensemble des contenus présents sur le site, notamment les textes, photographies, vidéos, musiques, enregistrements sonores, clips, visuels, logos, marques, éléments graphiques, interfaces, designs, bases de données, noms d’artistes, pochettes, contenus promotionnels et plus généralement tout élément composant le site, est protégé par le Code de la propriété intellectuelle.",
      "Toute reproduction, représentation, diffusion, adaptation, modification, exploitation commerciale, extraction ou réutilisation, totale ou partielle, sans autorisation écrite préalable d’Unlimited Session ou des titulaires de droits concernés, est strictement interdite.",
      "Toute utilisation non autorisée pourra faire l’objet de poursuites civiles et pénales.",
    ],
  },
  {
    title: "5. Droits musicaux et contenus artistiques",
    content: [
      "Les œuvres musicales, enregistrements, compositions, interprétations, vidéoclips, visuels promotionnels et contenus artistiques diffusés sur le site demeurent protégés par le droit d’auteur, les droits voisins et les droits des producteurs phonographiques.",
      "Aucune licence, cession ou autorisation d’exploitation n’est accordée à l’utilisateur du seul fait de sa navigation sur le site.",
      "Toute synchronisation, diffusion publique, reproduction, sampling, remix, mise à disposition, téléchargement non autorisé, exploitation commerciale ou utilisation promotionnelle des contenus musicaux est interdite sans autorisation écrite préalable.",
    ],
  },
  {
    title: "6. Marques",
    content: [
      "Les signes distinctifs Unlimited Session, ainsi que les logos, slogans, noms commerciaux, identités visuelles et éléments de marque associés, sont protégés.",
      "Toute utilisation non autorisée est interdite.",
      "Les marques, logos et signes distinctifs appartenant à des partenaires, artistes, distributeurs, plateformes ou collaborateurs, notamment LATDIOR Paris, demeurent la propriété exclusive de leurs titulaires respectifs.",
    ],
  },
  {
    title: "7. Boutique officielle et collaborations",
    content: [
      "Le site peut proposer à la vente des vêtements, accessoires, produits dérivés, éditions limitées ou articles issus de collaborations commerciales et artistiques.",
      "Les produits proposés peuvent être commercialisés directement par Unlimited Session ou dans le cadre de partenariats, notamment avec LATDIOR Paris.",
      "Les photographies, descriptions, tailles, coloris et visuels des produits sont fournis à titre indicatif. De légères différences peuvent exister entre les visuels affichés et les produits livrés.",
      "Les ventes réalisées sur le site sont soumises aux Conditions Générales de Vente disponibles sur le site.",
    ],
  },
  {
    title: "8. Données personnelles",
    content: [
      "Unlimited Session peut collecter et traiter certaines données personnelles dans le cadre de l’utilisation du site, notamment lors d’une demande de contact, d’une commande, d’une inscription à une newsletter ou d’une interaction avec les services proposés.",
      "Les données collectées peuvent être utilisées pour :",
    ],
    list: [
      "gérer les commandes ;",
      "répondre aux demandes des utilisateurs ;",
      "assurer le service client ;",
      "envoyer des informations commerciales lorsque l’utilisateur y a consenti ;",
      "améliorer le fonctionnement du site ;",
      "assurer la sécurité du site ;",
      "respecter les obligations légales applicables.",
    ],
    afterList: [
      "Unlimited Session s’engage à traiter les données personnelles conformément au Règlement Général sur la Protection des Données, dit RGPD, et à la loi Informatique et Libertés.",
      "L’utilisateur dispose d’un droit d’accès, de rectification, d’effacement, d’opposition, de limitation du traitement et de portabilité de ses données.",
      "Toute demande peut être adressée à :",
      "unlimitedsession@gmail.com",
    ],
  },
  {
    title: "9. Cookies",
    content: [
      "Le site peut utiliser des cookies ou technologies similaires destinés à assurer son bon fonctionnement, mesurer l’audience, améliorer l’expérience utilisateur ou proposer des contenus adaptés.",
      "L’utilisateur peut accepter, refuser ou paramétrer les cookies selon les modalités prévues sur le site ou via les paramètres de son navigateur.",
    ],
  },
  {
    title: "10. Responsabilité",
    content: [
      "Unlimited Session s’efforce d’assurer l’exactitude, la mise à jour et la disponibilité des informations diffusées sur le site.",
      "Toutefois, Unlimited Session ne garantit pas que le site soit exempt d’erreurs, d’interruptions, de bugs, d’inexactitudes ou d’indisponibilités temporaires.",
      "L’utilisateur reconnaît utiliser le site sous sa seule responsabilité.",
      "Unlimited Session ne pourra être tenue responsable des dommages directs ou indirects résultant de l’accès au site, de son utilisation, de son indisponibilité, ou de l’utilisation des informations qui y sont publiées.",
    ],
  },
  {
    title: "11. Liens externes",
    content: [
      "Le site peut contenir des liens vers des sites tiers, plateformes de streaming, réseaux sociaux, boutiques partenaires, médias ou services externes.",
      "Unlimited Session n’exerce aucun contrôle sur ces sites et décline toute responsabilité concernant leur contenu, leur fonctionnement, leurs pratiques commerciales ou leur politique de confidentialité.",
    ],
  },
  {
    title: "12. Signalement de contenu",
    content: [
      "Toute personne estimant qu’un contenu présent sur le site porte atteinte à ses droits peut adresser une demande motivée à :",
      "unlimitedsession@gmail.com",
      "La demande devra préciser l’identité du demandeur, le contenu concerné, l’emplacement exact du contenu litigieux, ainsi que les droits invoqués.",
    ],
  },
  {
    title: "13. Droit applicable",
    content: [
      "Les présentes mentions légales sont régies par le droit français.",
      "Tout litige relatif à l’utilisation du site, à son contenu ou à l’interprétation des présentes mentions relève des juridictions françaises compétentes, sauf disposition légale impérative contraire.",
    ],
  },
  ],
};

export function mergeLegalMentions(data) {
  const incoming = data && typeof data === "object" ? data : {};
  const defaultSections = DEFAULT_LEGAL_MENTIONS.sections;
  const incomingSections = Array.isArray(incoming.sections) ? incoming.sections : [];

  return {
    ...DEFAULT_LEGAL_MENTIONS,
    ...incoming,
    sections: defaultSections.map((section, index) => ({
      ...section,
      ...(incomingSections[index] || {}),
      content: Array.isArray(incomingSections[index]?.content)
        ? incomingSections[index].content
        : section.content || [],
      details: Array.isArray(incomingSections[index]?.details)
        ? incomingSections[index].details
        : section.details || null,
      list: Array.isArray(incomingSections[index]?.list)
        ? incomingSections[index].list
        : section.list || null,
      afterList: Array.isArray(incomingSections[index]?.afterList)
        ? incomingSections[index].afterList
        : section.afterList || null,
    })),
  };
}

function TextBlock({ children, site }) {
  return (
    <p className="readable-copy whitespace-pre-line text-base leading-8 text-gray-300 md:text-[17px]" style={typographyFor(site, "legalBody")}>
      {children}
    </p>
  );
}

export default function LegalMentions() {
  const [site, setSite] = useState({});
  const [legal, setLegal] = useState(() => mergeLegalMentions());

  useEffect(() => {
    const off = onSnapshot(
      doc(db, "admin", "content"),
      (snap) => {
        const data = snap.exists() ? snap.data() : {};
        setSite(data || {});
        setLegal(mergeLegalMentions(data.legalMentions));
      },
      () => {
        setSite({});
        setLegal(mergeLegalMentions());
      }
    );
    return () => off();
  }, []);

  return (
    <main className="min-h-screen bg-black px-6 py-24 text-white md:px-20">
      <article className="mx-auto max-w-[900px]">
        <header className="border-b border-white/10 pb-10">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.25em] text-red-500">
            Unlimited Session
          </p>
          <h1 className="text-4xl font-black uppercase tracking-normal md:text-6xl" style={typographyFor(site, "legalTitle")}>
            {legal.title}
          </h1>
          <p className="mt-5 text-sm font-bold uppercase tracking-[0.18em] text-gray-500">
            Dernière mise à jour : {legal.updatedAt}
          </p>
        </header>

        <div className="mt-10 space-y-10">
          {legal.sections.map((section) => (
            <section key={section.title} className="rounded-lg border border-white/10 bg-zinc-950 p-6 shadow-2xl shadow-black/20 md:p-8">
              <h2 className="text-2xl font-black uppercase text-white md:text-3xl" style={typographyFor(site, "legalSectionTitle")}>
                {section.title}
              </h2>

              <div className="mt-6 space-y-5">
                {section.content?.map((paragraph) => (
                  <TextBlock key={paragraph} site={site}>{paragraph}</TextBlock>
                ))}

                {section.details && (
                  <dl className="grid grid-cols-1 overflow-hidden rounded-lg border border-white/10 md:grid-cols-2">
                    {section.details.map(([label, value]) => (
                      <div key={label} className="border-b border-white/10 bg-black p-4 last:border-b-0 md:border-r md:even:border-r-0">
                        <dt className="text-xs font-bold uppercase tracking-[0.18em] text-red-400">
                          {label}
                        </dt>
                        <dd className="readable-copy mt-2 text-sm leading-7 text-gray-200" style={typographyFor(site, "legalBody")}>
                          {value}
                        </dd>
                      </div>
                    ))}
                  </dl>
                )}

                {section.list && (
                  <ul className="space-y-3 pl-5">
                    {section.list.map((item) => (
                      <li key={item} className="readable-copy list-disc text-base leading-8 text-gray-300 md:text-[17px]" style={typographyFor(site, "legalBody")}>
                        {item}
                      </li>
                    ))}
                  </ul>
                )}

                {section.afterList?.map((paragraph) => (
                  <TextBlock key={paragraph} site={site}>{paragraph}</TextBlock>
                ))}
              </div>
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}
